<template>
  <div
    class="month-event"
    :style="defaultStyle"
  >
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <span class="name">{{ userRealName }}</span>
        <span class="event-details">{{ eventDetails }} </span>
      </div>

      <div
        v-if="shiftSpillover"
        class="d-flex align-items-center"
      >
        <i
          v-tooltip="{ placement: 'top' }"
          class="hi-right"
          title="This shift continues into the next day"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'MonthViewEvent',
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapInertiaProps({
      timeZone: ({ time_zone: timeZone }) => timeZone.for,
    }),
    eventDetails() {
      return this.type !== 'Holiday' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
